export interface BlogPost {
  slug: string;
  title: string;
  date: string;
  description: string;
  featuredImage?: string;
  author: string;
  category: string;
  tags: string[];
  published: boolean;
  content: string;
  readingTime: number;
}

export interface BlogCategory {
  value: string;
  label: string;
  color: string;
}

export const BLOG_CATEGORIES: BlogCategory[] = [
  { value: 'getting-started', label: 'Getting Started', color: '#4caf50' },
  { value: 'tips-strategies', label: 'Tips & Strategies', color: '#2196f3' },
  { value: 'game-day', label: 'Game Day', color: '#9c27b0' },
  { value: 'updates', label: 'Feature Updates', color: '#ff9800' },
  { value: 'community', label: 'Community', color: '#e91e63' },
];

export function getCategoryLabel(value: string): string {
  const category = BLOG_CATEGORIES.find(c => c.value === value);
  return category?.label || value;
}

export function getCategoryColor(value: string): string {
  const category = BLOG_CATEGORIES.find(c => c.value === value);
  return category?.color || '#757575';
}
